import {
    FETCH_PROFILE,
    FETCH_PROFILE_SUCCESS,
    FETCH_PROFILE_FAIL
} from '../../types';

const initialState = {
    loading: false,
    userProfile: null,
    error: null
};

export const myProfileReducer = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case FETCH_PROFILE:
            return {
                ...state,
                loading: true
            };
        case FETCH_PROFILE_SUCCESS:
            return {
                ...state,
                loading: false,
                userProfile: action.payload,
                error: null
            };
        case FETCH_PROFILE_FAIL:
            return {
                ...state,
                loading: false,
                userProfile: null,
                error: action.payload
            };
        default:
            return state;
    }
};